<div class="aue-link-container">
  <label class="info-paragraph">{{aueTextBeginning}} </label>
  <a class="link" [attr.href]="aueLinkUrl" target="_blank" [attr.aria-label]="aueLinkText">
    {{aueLinkText}}
    <mat-icon
      fontSet="fas"
      fontIcon="fa-external-link-alt"
    ></mat-icon>
  </a>
  <label class="info-paragraph">{{aueTextEnd}}</label>
</div>
